module.exports = __webpack_public_path__ + "media/applicants/logo-f7eda1d1.svg";